/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import type { ElasticsearchProject } from '@modules/project-admin-api/v1/types'
import { getPatchProjectMutationHook } from '@modules/project-admin-lib/hooks/update'
import BoostWindow from '@modules/project-components/ProjectPage/BoostWindow'

export type Props = {
  project: ElasticsearchProject
}

const AdminBoostWindow: React.FunctionComponent<Props> = ({ project }) => {
  const patchProjectMutation = getPatchProjectMutationHook(project.type)()

  return (
    <BoostWindow
      project={project}
      error={patchProjectMutation.error}
      onChange={(boostWindow: number, onSuccess: () => void) => {
        patchProjectMutation.mutate(
          {
            id: project.id,
            body: { search_lake: { boost_window: boostWindow } },
          },
          { onSuccess },
        )
      }}
      isLoading={patchProjectMutation.isLoading}
    />
  )
}

export default AdminBoostWindow
